

const NotFound = () => {
  return (
    <div className="not-found"><h1>404</h1> NotFound!</div>
  )
}

export default NotFound